import { styled } from "../stitches.config";

const shadow = {
  true: {
    boxShadow: "$base",
  },
};
const defaultStyle = {
  padding: "0.75rem 1.5rem 0.75rem  1.5rem",
  borderRadius: ".5rem",
  backgroundColor: "white",
  height: "100%",
  boxSizing: "border-box",
};

export const stitchesCardStyles = {
  ...defaultStyle,
  variants: {
    shadow,
  },
};

export const StyledCardHeader = styled("h3", {
  fontFamily: "$header",
  text: "sm",
  margin: "0",
  "@sm": {
    text: "base",
  },
});
